import { client } from "api";
import { Comment } from "models/Comment";

export type EditCommentRequest = { checklistId: string; commentId: string; message: string };
export type EditCommentResponse = Comment;

export const editComment = (request: EditCommentRequest) =>
  client.patch<EditCommentResponse>(`/checklist/edit-comment`, request).then((res) => res.data);
